import type { HTMLAttributes, ReactNode } from 'react'

export type PillTone = 'neutral' | 'cyan' | 'green' | 'amber' | 'rose' | 'red' | 'purple'

interface PillProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: PillTone
  dot?: boolean
  glow?: boolean
  children: ReactNode
}

export function Pill({ tone = 'neutral', dot = false, glow = false, children, className, ...rest }: PillProps) {
  const classes = [
    'pill',
    tone !== 'neutral' && `pill--${tone}`,
    glow && 'pill--glow',
    className,
  ].filter(Boolean).join(' ')

  return (
    <span {...rest} className={classes}>
      {dot && <span className="pill__dot" aria-hidden="true" />}
      {children}
    </span>
  )
}
